export enum TRADE {
  DEAL = 'A1',
  LEASE = 'B1',
  RENT = 'B2',
  SHORTERMRENT = 'B3',
}

export enum FLOOR_INPUT_METHOD {
  DEFAULT = '00',
  DIRECT = '10',
  HIGH_MIDDLE_LOW = '20',
  NO_EXPOSURE = '30',
  ALL = '40',
}

export const NO_VALUE = '-'

export enum AREA_VIEW_MODE {
  PYEONG = 'pyeong',
  M2 = 'm2',
}

export enum FETCH_STATUS {
  INITIAL = 'initial',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum PROVIDER {
  KAB = 'kab',
  KBSTAR = 'kbstar',
  NEONET = 'neonet',
  REAL = 'real',
}

export const PRICE_PROVIDER = {
  [PROVIDER.KAB]: {
    CODE: PROVIDER.KAB,
    LABEL: '한국부동산원',
    TOOLTIP: '한국부동산원',
    MESSAGE: '에서 발표한 상한가와 하한가의 평균값',
  },
  [PROVIDER.KBSTAR]: {
    CODE: PROVIDER.KBSTAR,
    LABEL: 'KB부동산',
    TOOLTIP: 'KB부동산',
    MESSAGE: '에서 제공하는 해당 면적의 평균가',
  },
  [PROVIDER.NEONET]: {
    CODE: PROVIDER.NEONET,
    LABEL: '부동산뱅크',
    TOOLTIP: '부동산뱅크',
    MESSAGE: '에서 제공하는 해당 면적의 평균가',
  },
  [PROVIDER.REAL]: {
    CODE: PROVIDER.REAL,
    LABEL: '실거래가',
    TOOLTIP: '실거래가',
    MESSAGE: '',
  },
}

export enum AUTH_STATUS {
  APPLY1 = 'APLY1', //인증접수1차
  REJECT = 'RJT', //처리거절
  APPLY2 = 'APLY2', //인증접수2차
  COMPLETION = 'COMP', //인증완료
  FAIL = 'FAIL', //2차 후 최종 인증실패
  INITIAL = 'INIT', // 초기화. 입주민이 소유자로 넘어간경우, 주소를 수정 한 경우 등
}

export const MOBILE_REGEX = {
  IS_MOBILE: /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i,
  IS_IPHONE: /iphone|ipod/i,
  IS_ANDROID_APP: /naverland_android/i,
  IS_IOS_APP: /naverland_ios/i,
  IS_LAND_APP: /naverland_android|naverland_ios/i,
  IS_NAVER_APP: /NAVER\(inapp;/i,
  IS_IPAD: /iPad|iPhone|iPod/,
  IS_ANDROID: /android|Android/i,
  IS_CHROME: /chrome/i,
  IS_SAFARI: /safari/i,
  IS_PAY_APP: /NAVER\(inapp; pay;/i, //${Default UA} NAVER(inapp; pay; 710; 1.0.0; X)
}

export enum AUTH_APPLY_RESPONSE {
  ALREADY_AUTH_PROGRESS = 'ALREADY_AUTH_PROGRESS',
  ALREADY_AUTH_COMPLETE = 'ALREADY_AUTH_COMPLETE',
  INVALID_TRADE_TYPE = 'INVALID_TRADE_TYPE',
  AUTH_COUNT_OVER = 'AUTH_COUNT_OVER',
  AUTH_APPLY_SUCCESS = 'AUTH_APPLY_SUCCESS',
}

export enum THUMBNAIL {
  W700 = 'type=w700', // 게시글 내 첨부이미지
  M562 = 'type=m562',
  F176_176 = 'type=f176_176', // 게시글 목록 섬네일
}

export enum DATE_FORMAT {
  YYYYMMDD_THREE_DOT = 'YYYY. MM. DD.',
  YYYYMMDD_TWO_DOT = 'YYYY. MM. DD',
  YYYYMD_THREE_DOT = 'YYYY. M. D.',
  YYYYMD_TWO_DOT = 'YYYY. M. D',
  MMDD_TWO_DOT = 'MM. DD.',
  MD_TWO_DOT = 'M. D.',
}
